import { render, staticRenderFns } from "./filmlog.vue?vue&type=template&id=384b92e6&"
import script from "./filmlog.vue?vue&type=script&lang=js&"
export * from "./filmlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports